import { NgModule } from '@angular/core';

import { FuseIfOnDomDirective } from '@shared/@fuse/directives/fuse-if-on-dom/fuse-if-on-dom.directive';
import { FuseInnerScrollDirective } from '@shared/@fuse/directives/fuse-inner-scroll/fuse-inner-scroll.directive';
import {
  FuseMatSidenavHelperDirective,
  FuseMatSidenavTogglerDirective,
} from '@shared/@fuse/directives/fuse-mat-sidenav/fuse-mat-sidenav.directive';
import { FusePerfectScrollbarDirective } from '@shared/@fuse/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';

@NgModule({
  declarations: [
    FuseIfOnDomDirective,
    FuseInnerScrollDirective,
    FuseMatSidenavHelperDirective,
    FuseMatSidenavTogglerDirective,
    FusePerfectScrollbarDirective,
  ],
  imports: [],
  exports: [
    FuseIfOnDomDirective,
    FuseInnerScrollDirective,
    FuseMatSidenavHelperDirective,
    FuseMatSidenavTogglerDirective,
    FusePerfectScrollbarDirective,
  ],
})
export class FuseDirectivesModule {}
